import intl from 'react-intl-universal';

export const formatColumnDateValue = (date?: string): string => {
  if (!date) {
    return '';
  }
  return intl.get('DATES.SHORT_DATE', { date: new Date(date) });
};

export const toLocalDateString = (date?: string): string => {
  if (!date) {
    return '';
  }
  return new Date(date).toLocaleDateString('en-US');
};
